module.exports = __webpack_public_path__ + "img/女-慢性肾病h.39ee9e0d.png";